<div [style.min-height]="'330px'">
  <player-consents-v2-component [playerId]="playerId"></player-consents-v2-component>
</div>
